import { useState } from "react";
import { type Faq } from "@/mocks/faq";

export default function FaqAccordion({ items }: { items: Faq[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : index)}
                className="flex w-full items-center justify-between gap-4 py-5 text-left cursor-pointer"
                aria-expanded={isOpen}
              >
                <span
                  className={`font-heading text-sm font-semibold transition-colors md:text-base ${
                    isOpen ? "text-primary-600" : "text-foreground-900"
                  }`}
                >
                  {item.question}
                </span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                    isOpen
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 text-foreground-600"
                  }`}
                >
                  <i className={`text-base leading-none ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </span>
              </button>
            </h3>
            <div
              className={`grid overflow-hidden transition-all duration-300 ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="max-w-3xl pb-6 text-sm leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}